import { useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { grainsData, grainCategoryLabels } from '../data/grainsData';
import { Search, Filter, ChevronRight, Wheat } from 'lucide-react';

// AI-Generated images for grains
const grainImages = {
  'basmati-1121': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/7527556706218bef4e66989a625b238683623d4e466abbc1e1eee0e3576a5400.png',
  'basmati-1718': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/12500227c5d2eac964538ab957c608dfb8b328e5c15b650c344c51d6bb170bfc.png',
  'basmati-1509': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/4cbfdfb95f8bb1fbbecebd117b433721e6c841ef51f787da55d7aafe91649349.png',
  'basmati-1401': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/f8ce34fcef8b881e57fd41df5f158d87ce639fc7fbf5b49b9e91529330c8a512.png',
  'pusa-basmati': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/1d5020d04c70c03606a319dd6fdeb15ceb88fb17ae2a79b64e80012ca8c17bc5.png',
  'sugandha-rice': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/5acefecd047ba22340ae00636dc2f5a2c438c6b30c6ebb9774494934b8196d8b.png',
  'ir64-rice': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/3d7f2e24b658c0a7e3e9c613abc69cd4afeaaa9ec80f400002c84c1b0a05f734.png',
  'sona-masoori': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/fd80d42de7a45c99c0aee4bcc694a0ce1c14b8b11c597bb1ad872f80c26a6ff4.png',
  'ponni-rice': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/7239f80a614149cda59090ab88108da9c951f1f1e36f5a64ca75534e0d89a564.png',
  'kolam-rice': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/19bb44fd6d2ecf3043f22666ab76f86c1d8da4cc62700c0c7d837ee0482e9d6b.png',
  'swarna-rice': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/7b0be470d3dd685caafab1c8024e5bac23ee430ff9df320e612bb632ea66dcf9.png',
  'kalanamak-rice': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/4ba68b458f22e3f1caab85b1360d6b737fad6d6ee0e9582dfd578492b49978b4.png',
  'gobindobhog-rice': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/08252760c8a351151398c42bae5ca4326f1c49331a4fec3c3a2b8d29c5f48798.png',
  'ambemohar-rice': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/48da6f6bb9ad6be9c843cacbc7dd0c1838fa547ad82ef6fb70594824ed118c15.png',
  'joha-rice': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/3014c5f2f7ae563799045ce305a7b82705672a4a312ff717d0f9ab97b7afbcf7.png',
  'pokkali-rice': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/07dfeba5cd4c707fedaa14671c07f88119ae97715172ee0cfdc0a84b9df79b51.png',
  'navara-rice': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/0103cd4ef01cb998576856278798be4a9b3e7aa762711e89ac13853fc6ec5582.png',
  'palakkadan-matta': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/a29a375b1d0b2738c4577daf3686c2558351af2091b37b467a93bda7f8d7e02a.png',
  'indrayani-rice': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/be756d01ec681c126c460000508af547e432e19d9c36d097e06091cb1f7ceed3.png',
  'jeerakasala-rice': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/c2fdc30f3fe4df3209c47d716580fe3d23835091c74eab8edaa3fba988e9eea5.png',
  'durum-wheat': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/6e4a18aa6469d6f1ce86948d8370b077ff95ff8a14e32e7acf2f9b8ef81fd97f.png',
  'wheat-grain': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/41bf164c4e02badd6da5c077c167dcf89792dc8bfc42514763a056cbff6823be.png',
  'chickpeas-kabuli': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/77c50d94af871cd5345dc52a83e3b999a6015339acd4839d384d8674cce05894.png',
  'chickpeas-desi': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/7957362dde0572d84e4d873beac42f56252f0ed000b26404deced5c39e0d2f08.png',
  'red-lentils': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/1129fdee2f0db3c2abd9c5956e3d15347f4cc84ea60acc8848366ee402c10907.png',
  'pigeon-peas': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/dbb4cfc0e39b14f095b71978575815ebc358dd6509c2d7a3854c54644e39b8d4.png',
  'mung-beans': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/07bcee0cc86316352a56848a1c0409e3b41d92c9ec5217ef0af5a6547674b782.png',
  'black-gram': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/3781838b1368399c7806ad9d1bad1c501e96d38cf4a094c89a9f19b617a8800c.png',
  'kidney-beans': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/7be8e533e11f0bd2540308d7f9696a89c4c94326df68bff2ecea8a343fee258c.png',
  'pearl-millet': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/96ac66ee9e182b68b0310fe414fb3f3318e9b5739862b06a076786c3dcd2d2f1.png',
  'finger-millet': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/fe2a181bf026e9700549e3e2dfb74b1cf33815bdc9de8e2351c560f26c42f7c6.png',
  'sorghum': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/c3e018ef865d04bbd583d0034461eeb663992b07887663f5d71a3ef7ea95b800.png',
  'foxtail-millet': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/78f13f1151880c42bd031eeeb07dfe3eae11dc674d2f5c7dca44e34b63360d18.png',
  'maize-corn': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/045bc757dfe939adad6f951b93e3785a5aa2e7bf25b2d6225fa432a74210fc9e.png',
  'barley': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/391145b2e3eec4d8cfbed55dc6941d67977ccd29989a4317fdf637c82a7ed95a.png',
  'quinoa': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/64e09f010763f6cdae94cd7ecd9c8795970bee8fe9c5a680c5660b05779305ad.png',
};

const getGrainImage = (imageKey) => {
  return grainImages[imageKey] || 'https://images.unsplash.com/photo-1586201375761-83865001e31c?w=400&h=300&fit=crop';
};

export default function GrainsCatalogue() {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');

  const filteredGrains = useMemo(() => {
    return grainsData.filter(grain => {
      const matchesSearch = grain.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                           grain.botanicalName.toLowerCase().includes(searchQuery.toLowerCase()) ||
                           grain.description.toLowerCase().includes(searchQuery.toLowerCase());
      const matchesCategory = selectedCategory === 'all' || grain.category === selectedCategory;
      return matchesSearch && matchesCategory;
    });
  }, [searchQuery, selectedCategory]);

  const categories = useMemo(() => {
    const cats = [...new Set(grainsData.map(g => g.category))];
    return cats.sort((a, b) => {
      const order = ['basmati-rice', 'non-basmati-rice', 'specialty-rice', 'wheat', 'pulses', 'millets', 'cereals'];
      return order.indexOf(a) - order.indexOf(b);
    });
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <div className="relative bg-gradient-to-br from-[#263776] via-[#1e2d5f] to-[#263776] text-white overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-96 h-96 bg-[#F47D20] rounded-full filter blur-3xl -translate-x-1/2 -translate-y-1/2"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#F47D20] rounded-full filter blur-3xl translate-x-1/2 translate-y-1/2"></div>
        </div>
        <div className="container mx-auto px-4 py-16 relative z-10">
          {/* Breadcrumb */}
          <nav className="flex items-center text-sm mb-6 text-gray-300">
            <Link to="/" className="hover:text-[#F47D20] transition-colors">Home</Link>
            <ChevronRight className="w-4 h-4 mx-2" />
            <Link to="/products" className="hover:text-[#F47D20] transition-colors">Products</Link>
            <ChevronRight className="w-4 h-4 mx-2" />
            <span className="text-[#F47D20]">Cereals, Pulses & Grains</span>
          </nav>
          
          <div className="flex items-center gap-4 mb-4">
            <div className="w-14 h-14 bg-[#F47D20]/20 rounded-xl flex items-center justify-center">
              <Wheat className="w-7 h-7 text-[#F47D20]" />
            </div>
            <h1 className="text-4xl md:text-5xl font-bold">Cereals, Pulses & Grains</h1>
          </div>
          <p className="text-lg md:text-xl text-gray-300 max-w-3xl mb-8">
            India is a major exporter of rice, wheat, pulses, and millets. Explore our comprehensive catalogue 
            featuring premium Basmati rice varieties, non-Basmati rice, pulses, and nutritious millets.
          </p>
          
          {/* Search and Filter */}
          <div className="flex flex-col sm:flex-row gap-4 max-w-2xl">
            <div className="relative flex-1">
              <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
              <input
                type="text"
                placeholder="Search grains, rice, pulses..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full pl-12 pr-4 py-3 rounded-lg bg-white/10 backdrop-blur border border-white/20 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#F47D20] focus:border-transparent"
                data-testid="grain-search-input"
              />
            </div>
            <div className="relative">
              <Filter className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
              <select
                value={selectedCategory}
                onChange={(e) => setSelectedCategory(e.target.value)}
                className="w-full sm:w-auto pl-12 pr-8 py-3 rounded-lg bg-white/10 backdrop-blur border border-white/20 text-white focus:outline-none focus:ring-2 focus:ring-[#F47D20] focus:border-transparent appearance-none cursor-pointer"
                data-testid="grain-category-filter"
              >
                <option value="all" className="bg-[#263776]">All Categories</option>
                {categories.map(cat => (
                  <option key={cat} value={cat} className="bg-[#263776]">
                    {grainCategoryLabels[cat]}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </div>

      {/* Grains Grid */}
      <div className="container mx-auto px-4 py-12">
        <div className="flex items-center justify-between mb-8">
          <p className="text-gray-600">
            Showing <span className="font-semibold text-[#263776]">{filteredGrains.length}</span> products
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {filteredGrains.map((grain) => (
            <Link
              key={grain.id}
              to={`/products/grains/${grain.id}`}
              className="group bg-white rounded-xl shadow-sm hover:shadow-xl transition-all duration-300 overflow-hidden border border-gray-100"
              data-testid={`grain-card-${grain.id}`}
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={getGrainImage(grain.image)}
                  alt={grain.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <span className="absolute top-3 right-3 px-2 py-1 bg-[#F47D20] text-white text-xs font-medium rounded-full">
                  {grainCategoryLabels[grain.category]}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-lg font-semibold text-[#263776] group-hover:text-[#F47D20] transition-colors mb-1">
                  {grain.name}
                </h3>
                <p className="text-sm text-gray-500 italic mb-2">{grain.botanicalName}</p>
                <p className="text-sm text-gray-600 line-clamp-2">
                  {grain.description.substring(0, 100)}...
                </p>
                <div className="mt-3 flex items-center text-[#F47D20] text-sm font-medium">
                  View Details
                  <ChevronRight className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" />
                </div>
              </div>
            </Link>
          ))}
        </div>

        {filteredGrains.length === 0 && (
          <div className="text-center py-16">
            <div className="w-24 h-24 mx-auto mb-6 bg-gray-100 rounded-full flex items-center justify-center">
              <Search className="w-10 h-10 text-gray-400" />
            </div>
            <h3 className="text-xl font-semibold text-gray-700 mb-2">No products found</h3>
            <p className="text-gray-500">Try adjusting your search or filter criteria</p>
          </div>
        )}
      </div>

      {/* Info Section */}
      <div className="bg-[#263776] text-white py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl font-bold mb-6">Premium Quality Grains</h2>
            <p className="text-gray-300 mb-8">
              SPANXPORT sources cereals, pulses, and grains from India's prime agricultural regions.
              Our products meet international quality standards with complete traceability and documentation.
            </p>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              <div className="text-center">
                <div className="text-4xl font-bold text-[#F47D20] mb-2">30+</div>
                <div className="text-sm text-gray-300">Grain Varieties</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-[#F47D20] mb-2">APEDA</div>
                <div className="text-sm text-gray-300">Registered</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-[#F47D20] mb-2">Global</div>
                <div className="text-sm text-gray-300">Export Ready</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-[#F47D20] mb-2">Non-GMO</div>
                <div className="text-sm text-gray-300">Certified</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="container mx-auto px-4 py-16">
        <div className="bg-gradient-to-r from-[#F47D20] to-[#ff9a4d] rounded-2xl p-8 md:p-12 text-white text-center">
          <h2 className="text-2xl md:text-3xl font-bold mb-4">Need Bulk Grains?</h2>
          <p className="text-white/90 mb-6 max-w-2xl mx-auto">
            Contact our team for competitive pricing on bulk orders, specific grades, 
            and tailored packaging solutions for your business needs.
          </p>
          <Link
            to="/contact"
            className="inline-flex items-center px-8 py-3 bg-white text-[#F47D20] font-semibold rounded-lg hover:bg-gray-100 transition-colors"
            data-testid="grain-catalogue-get-quote-btn"
          >
            Get a Quote
            <ChevronRight className="w-5 h-5 ml-2" />
          </Link>
        </div>
      </div>
    </div>
  );
}
